import React from 'react';
import { Button } from "reactstrap";
import { RolesConstants } from '../../constants/roles';
import useSignUp from "../../hooks/useSignUp";
import Styles from './ContractorSignInButton.module.css';
import ContractorImg from './assets/contractor.png'

function ContractorSignInButton() {
    const signup = useSignUp();

  return (
    <Button className={Styles.buttonContractor} color='link'
      onClick={(e) => {
        e.preventDefault();
        signup.signupWithRole(RolesConstants.CONTRACTOR);
      }}
    >
      <img src={ContractorImg} alt="" className="img-fluid" />
      I'm a Contractor
    </Button>
  );
}

export default ContractorSignInButton;
